let musicartWallet = 'MUSICART_WALLET';
let handCashBSVWallet = 'HANDCASH_BSV_WALLET';
let handCashUSDCWallet = 'HANDCASH_USDC_WALLET';

export { musicartWallet, handCashBSVWallet, handCashUSDCWallet };
